import { lazy, Suspense } from 'react';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { HeroSection } from '@/components/landing/HeroSection';
import { SignalTicker } from '@/components/landing/SignalTicker';
import { BriefStrip } from '@/components/landing/BriefStrip';

// Below-fold sections are code-split — the radar hero stays eager,
// everything else hydrates as the viewport approaches.
const CapabilityGrid = lazy(() =>
  import('@/components/landing/CapabilityGrid').then((m) => ({ default: m.CapabilityGrid })),
);
const Workflow = lazy(() =>
  import('@/components/landing/Workflow').then((m) => ({ default: m.Workflow })),
);
const VsSansan = lazy(() =>
  import('@/components/landing/VsSansan').then((m) => ({ default: m.VsSansan })),
);
const PricingStrip = lazy(() =>
  import('@/components/landing/PricingStrip').then((m) => ({ default: m.PricingStrip })),
);
const FaqColumn = lazy(() =>
  import('@/components/landing/FaqColumn').then((m) => ({ default: m.FaqColumn })),
);
const FinalCta = lazy(() =>
  import('@/components/landing/FinalCta').then((m) => ({ default: m.FinalCta })),
);

const SectionFallback = () => <div style={{ minHeight: 400 }} />;

export function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />

      <main className="flex-1">
        <SignalTicker />
        <HeroSection />
        <BriefStrip />
        <Suspense fallback={<SectionFallback />}><CapabilityGrid /></Suspense>
        <Suspense fallback={<SectionFallback />}><Workflow /></Suspense>
        <Suspense fallback={<SectionFallback />}><VsSansan /></Suspense>
        <Suspense fallback={<SectionFallback />}><PricingStrip /></Suspense>
        <Suspense fallback={<SectionFallback />}><FaqColumn /></Suspense>
        <Suspense fallback={<SectionFallback />}><FinalCta /></Suspense>
      </main>

      <SiteFooter />
    </div>
  );
}
